import React, { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from './CodeSample';
import CodeBlock from '../CodeBlock';
import { User } from '../../../interfaces/backend/User';
import { readWebsiteVariable } from '../../../utils/readWebsiteVariable';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

export default class BackendNodeJsSample extends BackendCodeSample {
  name = 'Node.js';
  language = 'javascript';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = '//';

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const npmInstall = `npm install notificationapi-node-server-sdk
# For yarn users: yarn add notificationapi-node-server-sdk
`;

    if (!environment || !notification) {
      return 'loading';
    }

    const code = `import notificationapi from 'notificationapi-node-server-sdk'
// const notificationapi = require('notificationapi-node-server-sdk').default

notificationapi.init(
  '${environment.clientId}', // clientId
  '${environment.clientSecret}'${
      readWebsiteVariable('REACT_APP_aws_project_region') === 'us-east-1'
        ? '// clientSecret'
        : `// clientSecret,
  'https://api.ca.notificationapi.com' // baseURL to send notification from canada region    `
    }
)

notificationapi.send({
  notificationId: '${notification.notificationId}',
  user: {
    ${this.buildUserObjectString(user, '\n    ')}
  },
  mergeTags: ${JSON.stringify(mergeTags, null, 4).slice(0, -1) + '  }'}
})`;

    return (
      <>
        <CodeBlock language="bash" code={npmInstall} />
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `id: "${user.id}"`,
      email: `email: "${user.email}"`,
      number: {
        value: `number: "${user.number}"`,
        comment: 'Replace with your phone number'
      }
    };
  }
}
